import { forwardRef } from "react";
import { EventsTrackWrapperSpecialProps } from "./EventsTrackWrapper.interface";
import EventsTrackWrapperBase from "./EventsTrackWrapperBase";

const EventsTrackWrapperClick = forwardRef<unknown, EventsTrackWrapperSpecialProps>((props, ref) => {
    return <EventsTrackWrapperBase ref={ref} type="click" {...props} />;
});

export default EventsTrackWrapperClick;